export const defaultSuccessCases = [
  {
    title: `P4 Engenharia`,
    text: `Tarefas repetitivas passam a ser executadas por Robos`,
    quantity: 74,
  },
  {
    title: `SASCAR`,
    text: `Aderências ao sistema Totvs`,
    quantity: 32,
  },
  {
    title: `UNIMED Rio Preto`,
    text: `Projeto de transformção digital e redução de atividades manuais`,
    quantity: 96,
  },
  {
    title: `Okubo`,
    text: `Estruturação da área comercial e aumento da aderência aos sistemas da empresa`,
    quantity: 40,
  },
  {
    title: `CTG Brasil`,
    text: `Implementação das normas 9001 / 14001 / 45001 / 55001`,
    quantity: 500,
  },
  {
    title: `UNIMED Botucatu`,
    text: `Adequação para atendimento a resolução normativa RN 443 / 2019`,
    quantity: 100,
  },
  {
    title: `Biosev`,
    text: `Documentação dos processos de Originação e transformação de atividades manuais`,
    quantity: 60,
  },
]
